module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "book"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }), _c('div', {
    staticClass: "verse"
  }, [_c('i', [_vm._v(" For all our darlings whose")]), _c('br')]), _c('div', {
    staticClass: "verse"
  }, [_c('i', [_vm._v(" gifts were lost too soon—")]), _c('br')]), _c('div', {
    staticClass: "verse"
  }, [_c('i', [_vm._v(" would any of these")]), _c('br')]), _c('div', {
    staticClass: "verse"
  }, [_c('i', [_vm._v(" could have saved you for us")]), _c('br')]), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60530fdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 69
// module chunks = 0